import { render, staticRenderFns } from "./v-radio-group.vue?vue&type=template&id=770c2552&scoped=true"
import script from "./v-radio-group.vue?vue&type=script&lang=js"
export * from "./v-radio-group.vue?vue&type=script&lang=js"
import style0 from "./v-radio-group.vue?vue&type=style&index=0&id=770c2552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../com-tool/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c2552",
  null
  
)

export default component.exports